import {Nut_Settings_User} from 'nutshell-core/settings-constants';

import type {GetUserAiFeatureSettings_user as UserAiFeatureSettings} from 'nutshell-graphql-types';

import type {AiFeatureSetting} from './user-ai-features';

export function getIsFeatureEnabled(
    feature: AiFeatureSetting,
    settings: UserAiFeatureSettings | null
): boolean {
    if (!settings) {
        return feature.defaultEnabled;
    }

    switch (feature.settingName) {
        case Nut_Settings_User.SETTING_AI_FOLLOW_UP_TASKS_ENABLED:
            return settings.isAiFollowUpTasksEnabled;
        default:
            return feature.defaultEnabled;
    }
}
